import { selectors as catalogSelectors } from 'dux/catalog';
import { selectors as instanceSelectors } from 'dux/instances';
import { selectors as userSelectors } from 'dux/user';
import { actionCreators } from 'dux/createInstance';
import { connect } from 'react-redux';
import RegionsTab from './RegionsTab';

const mapStateToProps = (state) => ({
  catalog: catalogSelectors.getCatalogState(state),
  userRoles: userSelectors.getIdentityState(state).roles,
  getAssociatedCockroachDBInstances: instanceSelectors.getAssociatedCockroachDBInstances(state),
});

const mapDispatchToProps = {
  createInstance: actionCreators.createInstance,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegionsTab);
